<div class="auth-card__otp-boxes">
  @for (digit of digits(); track $index) {
    <input
      #otpBox
      type="text"
      inputmode="numeric"
      maxlength="1"
      class="auth-card__otp-box"
      [value]="digit"
      (input)="onDigitInput($index, $event)"
      (keydown)="onKeydown($index, $event)"
    />
  }
</div>
<p class="auth-card__otp-timer">
  <span aria-hidden="true">🕑</span> Code will expire in <strong>{{ expiryLabel() }}</strong>
</p>
<div class="auth-card__otp-resend">
  @if (resendSeconds() > 0) {
    <span>Didn't receive the code? <strong>Resend OTP</strong></span>
    <span>You can resend in <strong>{{ resendLabel() }}</strong></span>
  } @else {
    <button type="button" class="auth-card__otp-resend-btn" (click)="requestResend()">
      Didn't receive the code? <strong>Resend OTP</strong>
    </button>
  }
</div>
